import { compose, mdsWidget } from 'dojo/_base/declare';
import on from 'dojo/on';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import domStyle from 'dojo/dom-style';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
// template-instantiated child widget (data-dojo-type in ExecutionChangeDlg.html) — side-effect import.
import "../../../moreCore/UI/HintBox/HintBox";
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import TaskExecutionForm from './TaskExecutionForm';

import template from './ExecutionChangeDlg.html?raw';

class ExecutionChangeDlg extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    isExternalEmployee = false;

    taskExecutionForm: any = null;

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.RequestManager.silentExceptions = true;
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    show(): void {
        if (this._statusChangeDlg) {
            this._statusChangeDlg.show();
        }
    }

    getData(): any {
        var note = this.taskInput.value;
        var data: any = {
            Note: note,
        };

        if (this.isUseAssistants()) {
            data.Assistants = this.taskExecutionForm._assistantData;
            data.AssistantsWorkamounts = this.taskExecutionForm.getAssistantWorkamounts();
        }

        if (this.isUseMaterial()) {
            data.Material = this.taskExecutionForm._materialData;
        }

        if (this.isUseFlatrates()) {
            data.Flatrates = this.taskExecutionForm._flatratesData;
        }

        if (this.isUseWorkamount()) {
            data.Workamount = this.taskExecutionForm.getWorkingAmount();
        }

        if (this.isUseWorkdate()) {
            data.Workdate = this.taskExecutionForm.getWorkingDate();
        }

        return data;
    }

    isUseAssistants(): any {
        return this.taskExecutionForm.isUseAssistants();
    }

    isUseFlatrates(): any {
        return this.taskExecutionForm.isUseFlatrates();
    }

    isUseMaterial(): any {
        return this.taskExecutionForm.isUseMaterial();
    }

    isUseWorkamount(): any {
        return this.taskExecutionForm.isUseWorkamount();
    }

    isUseWorkdate(): any {
        return this.taskExecutionForm.isUseWorkdate();
    }


    setup(taskEntity: any, header: any, subtitle: any, callback: any, modes?: any, executionEntity?: any): void {
        var dialog = new GenericDialog;
        this._statusChangeDlg = dialog;
        dialog.destroyOnClose = false;
        dialog.closeOnEnter = false;
        domStyle.set(dialog.textNode, "height", "unset");
        domStyle.set(dialog.textNode, "maxHeight", "unset");
        dialog.hideSubtitleNode(true);
        dialog.set("ok", true);
        dialog.set("cancel", true);
        //dialog.set("content", "Hier Freitexteingabe");
        domAttr.set(this.subtitleText, "innerHTML", subtitle); // eigener Subtitle-Knoten im inputdiv, der dann zum Content kommt!
        dialog.set("header", header);//taskEntity.Number + " erledigen");

        var inputDiv = this.inputDiv;//domConstruct.create("div");
        domClass.remove(inputDiv, "w3-hide");

        if (modes) {
            this.hideNode(this.notesContainer, modes?.indexOf("-HideNotes") != -1);
        }

        this.taskExecutionForm = new TaskExecutionForm();
        this.taskExecutionForm.setup(taskEntity, this.isExternalEmployee, modes, executionEntity);
        this.taskExecutionForm.placeAt(inputDiv);


        var input = this.taskInput; //domConstruct.create("textarea", {}, inputDiv);
        input.value = "";

        if (modes && modes.indexOf("-DisableNotes") != -1) this.disableNode(input);

        if (executionEntity && executionEntity.Note) {
            input.value = executionEntity.Note;
        } else {
            if (modes && modes.indexOf("-DisableNotes") != -1) this.hideNode(this.notesContainer);
        }

        //domClass.add(input, "w3-input w3-block");
        dialog.addNodeToContent(inputDiv);
        //domAttr.set(input, "placeholder", this.translations["OccurrenceTaskExecutions__DialogConfirmFinish_NotesPlaceholder"]);//"Anmerkungen?");
        //domAttr.set(input, "placeholder", this.translations["OccurrenceTaskExecutions__DialogConfirmFinish_NotesPlaceholder"]);//"Anmerkungen?");

        //domAttr.set(input, "value", this.comment); // es sollte ein Standardtext irgendwoher kommen...

        // verhinden dass mit "Enter" der Dialog beendet wird
        on(dialog.domNode, "keyup", function (evt) {
            evt.stopPropagation();
        });


        dialog.set("callback", callback);

        dialog.show();

        //console.log("cell mehrfachauswahl", cell, cellData, options);

        input.style.width = "100%";
    }
}
ExecutionChangeDlg.prototype.declaredClass = 'WidgetCollection.JDM.TaskExecution.ExecutionChangeDlg';

export default mdsWidget(ExecutionChangeDlg);
